/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Postal/NewAddress/Content/SearchForAddress/Content/Content/SaveAction",
  isSubmitting
  
}) {
let newAddressIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'new_address',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={dtSpaceS}
 type="primary"
 block={true}
 data="new_address"
 disabled={newAddressIsSubmittingData}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save Anyway"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}